
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  computed: {
    parsedText() {
      const segments = (this as any).text.split(/<b>|<\/b>/);
      return segments.map((segment: string, index: number) => ({
        text: segment,
        isBold: index % 2 !== 0
      }));
    }
  }
})
export default class PatientName extends Vue {
  @Prop({ required: true }) readonly text!: string;
}
